module.exports = __webpack_public_path__ + "img/simples_nacional.e5b0c4fa.png";